import React from 'react';
import { StyledCard, CardHeader, CardHeaderText, CardIdentifiers } from './styles';

export const ShipmentCard = props => {
  const {
    label,
    index,
    itemsCount,
    handleOpen
  } = props;

  return (
    <StyledCard>
      <CardHeader onClick={() => handleOpen(index)}>
        <CardIdentifiers component={CardHeaderText}>
          {label}
        </CardIdentifiers>
        <CardHeaderText>
          {itemsCount}
        </CardHeaderText>
      </CardHeader>
    </StyledCard>
  );
};
